type SVGIconProps = {
  iconName: string;
  className?: string;
} & React.SVGProps<SVGSVGElement>;

const SVGIcon = ({
  iconName,
  viewBox = "0 0 22 22",
  width = "22",
  height = "22",
}: SVGIconProps) => getSvgIcon(iconName, width, height, viewBox);

type GetSvgIcon = (
  iconName: string,
  width: string | number,
  height: string | number,
  viewBox: string
) => JSX.Element | null;

const getSvgIcon: GetSvgIcon = (name, width, height, viewBox) => {
  switch (name) {
    case "caretUp":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polygon
            fill="#B6B8C7"
            fillRule="evenodd"
            points="1 3.5 11 3.5 6 8.5"
            transform="rotate(-180 6 6)"
          />
        </svg>
      );
    case "caretDown":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polygon
            fill="#B6B8C7"
            fillRule="evenodd"
            points="1 3.5 11 3.5 6 8.5"
          />
        </svg>
      );
    case "upload":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox={viewBox}
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(1 4)"
          >
            <path
              strokeLinejoin="round"
              d="M4.85795455,11.7333333 L3.45454545,11.7333333 C1.54665268,11.7333333 0,10.2324213 0,8.38095238 C0,6.5294835 1.54665268,5.02857143 3.45454545,5.02857143 C3.76407677,5.02857143 4.0640999,5.06807683 4.34955286,5.14217535 C4.32883137,4.96741229 4.31818182,4.78967494 4.31818182,4.60952381 C4.31818182,2.06375411 6.44482926,0 9.06818182,0 C11.2854225,0 13.1478407,1.47424715 13.6713332,3.46774183 C13.9954795,3.39232352 14.3338422,3.35238095 14.6818182,3.35238095 C17.0666841,3.35238095 19,5.22852105 19,7.54285714 C19,9.8571932 17.0666841,11.7333333 14.6818182,11.7333333 L14.1420455,11.7333333"
            />
            <g transform="matrix(1 0 0 -1 7 15)">
              <path d="M2.53333333,0.533333333 L2.53333333,6.93333333" />
              <polyline
                strokeLinejoin="round"
                points="4.533 6 2.533 8 .533 6"
              />
            </g>
          </g>
        </svg>
      );
    case "search-16":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#333"
            strokeWidth="2"
            transform="translate(1 1)"
          >
            <circle cx="5.444" cy="5.444" r="5.444" />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.33333333,9.33333333 L14,14"
            />
          </g>
        </svg>
      );

    case "search":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g fill="currentColor" transform="translate(2 2)">
            <path d="M6.81553398,13.3601942 C4.1107552,13.3757634 1.66360484,11.7585207 0.617561695,9.26415413 C-0.428481446,6.76978759 0.133115415,3.89078984 2.03993518,1.9724288 C3.94675494,0.054067766 6.82231142,-0.524891648 9.32294469,0.506080654 C11.823578,1.53705296 13.4555582,3.97439981 13.4563107,6.6792233 C13.4640504,10.3565417 10.4928321,13.3457436 6.81553398,13.3601942 Z M6.81553398,1.77378641 C4.8268756,1.75678881 3.02459402,2.94173815 2.25192379,4.77423147 C1.47925357,6.6067248 1.88899583,8.72437329 3.28944422,10.1363915 C4.68989262,11.5484097 6.80409833,11.9755607 8.64288668,11.2179933 C10.481675,10.4604258 11.6814123,8.66795422 11.6807767,6.6792233 C11.6875615,3.982893 9.51182884,1.78918552 6.81553398,1.77378641 Z" />
            <rect
              width="1"
              height="5.314"
              x="12.71"
              y="10.316"
              transform="rotate(-45 13.147 12.973)"
            />
            <rect
              width="7.635"
              height="2.454"
              x="10.775"
              y="13.192"
              rx="1.227"
              transform="rotate(45 14.593 14.419)"
            />
          </g>
        </svg>
      );
    case "filterResults":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g fill="none" fillRule="evenodd" transform="translate(4 4)">
            <polyline
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.579"
              points="0 0 0 14.215 14.23 14.215"
            />
            <path
              fill="currentColor"
              fillRule="nonzero"
              d="M2.36842105 12.6315789L2.36842105 7.50374116C2.36842105 6.84765355 2.89405044 6.31578947 3.55263158 6.31578947 4.20665299 6.31578947 4.73684211 6.84340697 4.73684211 7.50374116L4.73684211 12.6315789 2.36842105 12.6315789zM6.31578947 12.6315789L6.31578947 1.96823396C6.31578947 1.31722264 6.84141884.789473684 7.5.789473684 8.15402139.789473684 8.68421053 1.31359409 8.68421053 1.96823396L8.68421053 12.6315789 6.31578947 12.6315789zM10.2631579 12.6315789L10.2631579 4.33858832C10.2631579 3.68650926 10.7887873 3.15789474 11.4473684 3.15789474 12.1013898 3.15789474 12.6315789 3.6943851 12.6315789 4.33858832L12.6315789 12.6315789 10.2631579 12.6315789z"
            />
          </g>
        </svg>
      );
    case "filters":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <path
            fill="currentColor"
            d="M5.18159492,12.4444444 L15.1169798,12.4444444 C15.6046584,12.4444444 16,12.8389909 16,13.3333333 C16,13.8242531 15.6044922,14.2222222 15.1169798,14.2222222 L5.18159492,14.2222222 C4.81551812,15.2579488 3.82775007,16 2.66666667,16 C1.19390733,16 0,14.8060926 0,13.3333333 C0,11.860574 1.19390733,10.6666667 2.66666667,10.6666667 C3.82775007,10.6666667 4.81551812,11.4087179 5.18159492,12.4444444 Z M5.48507174,8.88888889 L0.88302016,8.88888889 C0.395341591,8.88888889 0,8.4943424 0,8 C0,7.50908027 0.395507813,7.11111111 0.88302016,7.11111111 L5.48507174,7.11111111 C5.85114855,6.07538456 6.83891662,5.33333333 8,5.33333333 C9.16108338,5.33333333 10.1488515,6.07538456 10.5149283,7.11111111 L15.1169798,7.11111111 C15.6046584,7.11111111 16,7.5056576 16,8 C16,8.49091973 15.6044922,8.88888889 15.1169798,8.88888889 L10.5149283,8.88888889 C10.1488515,9.92461547 9.16108338,10.6666667 8,10.6666667 C6.83891662,10.6666667 5.85114855,9.92461547 5.48507174,8.88888889 Z M10.8141903,3.54353883 C10.7666244,3.55144318 10.7177867,3.55555556 10.667998,3.55555556 L0.887557627,3.55555556 C0.397373084,3.55555556 0,3.16100905 0,2.66666667 C0,2.17574689 0.397768382,1.77777778 0.887557627,1.77777778 L10.667998,1.77777778 C10.7178057,1.77777778 10.7666552,1.78185132 10.8142269,1.7896892 C11.1769194,0.74774528 12.1678037,0 13.3333333,0 C14.8060926,0 16,1.19390733 16,2.66666667 C16,4.139426 14.8060926,5.33333333 13.3333333,5.33333333 C12.1677644,5.33333333 11.1768526,4.58553767 10.8141903,3.54353883 Z M13.3333333,3.55555556 C13.8242531,3.55555556 14.2222222,3.15758644 14.2222222,2.66666667 C14.2222222,2.17574689 13.8242531,1.77777778 13.3333333,1.77777778 C12.8424136,1.77777778 12.4444444,2.17574689 12.4444444,2.66666667 C12.4444444,3.15758644 12.8424136,3.55555556 13.3333333,3.55555556 Z M8,8.88888889 C8.49091973,8.88888889 8.88888889,8.49091973 8.88888889,8 C8.88888889,7.50908027 8.49091973,7.11111111 8,7.11111111 C7.50908027,7.11111111 7.11111111,7.50908027 7.11111111,8 C7.11111111,8.49091973 7.50908027,8.88888889 8,8.88888889 Z M2.66666667,14.2222222 C3.15758644,14.2222222 3.55555556,13.8242531 3.55555556,13.3333333 C3.55555556,12.8424136 3.15758644,12.4444444 2.66666667,12.4444444 C2.17574689,12.4444444 1.77777778,12.8424136 1.77777778,13.3333333 C1.77777778,13.8242531 2.17574689,14.2222222 2.66666667,14.2222222 Z"
            transform="translate(3 3)"
          />
        </svg>
      );
    case "message":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g fill="none" fillRule="evenodd" transform="translate(2 4)">
            <path
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3.07353123,11.6666667 L5.39390847,13.922589 L6,14.5118447 L6.60609153,13.922589 L8.9264688,11.6666667 L15.4306761,11.6666667 C16.3774473,11.6666667 17.1428571,10.9186839 17.1428571,9.99793892 L17.1428571,1.66872774 C17.1428571,0.753466183 16.3785336,0 15.4342305,0 L1.70862658,0 C0.763354551,0 0,0.748833125 0,1.66872774 L0,9.99793892 C0,10.9142286 0.767551783,11.6666667 1.71339134,11.6666667 L3.07353123,11.6666667 Z"
            />
            <rect
              width="10.286"
              height="2"
              x="3.429"
              y="3.107"
              fill="currentColor"
              fillRule="nonzero"
              rx=".8"
            />
            <rect
              width="10.286"
              height="2"
              x="3.429"
              y="6.429"
              fill="currentColor"
              fillRule="nonzero"
              rx=".8"
            />
          </g>
        </svg>
      );
    case "emptyMessage":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g fill="none" fillRule="evenodd" transform="translate(2 4)">
            <path
              stroke="#B6B8C7"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3.07353123,11.6666667 L5.39390847,13.922589 L6,14.5118447 L6.60609153,13.922589 L8.9264688,11.6666667 L15.4306761,11.6666667 C16.3774473,11.6666667 17.1428571,10.9186839 17.1428571,9.99793892 L17.1428571,1.66872774 C17.1428571,0.753466183 16.3785336,0 15.4342305,0 L1.70862658,0 C0.763354551,0 0,0.748833125 0,1.66872774 L0,9.99793892 C0,10.9142286 0.767551783,11.6666667 1.71339134,11.6666667 L3.07353123,11.6666667 Z"
            />
            <rect
              width="10.286"
              height="2"
              x="3.429"
              y="3.107"
              fill="#B6B8C7"
              fillRule="nonzero"
              rx=".8"
            />
            <rect
              width="10.286"
              height="2"
              x="3.429"
              y="6.429"
              fill="#B6B8C7"
              fillRule="nonzero"
              rx=".8"
            />
          </g>
        </svg>
      );
    case "download":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(1 3)"
          >
            <path
              strokeLinejoin="round"
              d="M4.85795455,11.7333333 L3.45454545,11.7333333 C1.54665268,11.7333333 0,10.2324213 0,8.38095238 C0,6.5294835 1.54665268,5.02857143 3.45454545,5.02857143 C3.76407677,5.02857143 4.0640999,5.06807683 4.34955286,5.14217535 C4.32883137,4.96741229 4.31818182,4.78967494 4.31818182,4.60952381 C4.31818182,2.06375411 6.44482926,0 9.06818182,0 C11.2854225,0 13.1478407,1.47424715 13.6713332,3.46774183 C13.9954795,3.39232352 14.3338422,3.35238095 14.6818182,3.35238095 C17.0666841,3.35238095 19,5.22852105 19,7.54285714 C19,9.8571932 17.0666841,11.7333333 14.6818182,11.7333333 L14.1420455,11.7333333"
            />
            <path d="M9.53333333,9.53333333 L9.53333333,15.9333333" />
            <polyline
              strokeLinejoin="round"
              points="11.667 14.867 9.533 17 7.4 14.867"
            />
          </g>
        </svg>
      );
    case "eye":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            transform="translate(2 5)"
          >
            <path
              strokeLinejoin="round"
              strokeWidth="2"
              d="M0,6 C0,6 2.7,0 9,0 C15.3,0 18,6 18,6 C18,6 15.3,12 9,12 C2.7,12 0,6 0,6 Z"
            />
            <ellipse
              cx="9"
              cy="6"
              fill="currentColor"
              strokeWidth="1.8"
              rx="2.7"
              ry="2.571"
            />
          </g>
        </svg>
      );
    case "edit":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g fill="none" fillRule="evenodd">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.75"
              d="M4,17.7955037 L4,14.2955034 L13.5281955,4.76730787 C14.5521834,3.74331998 16.2100132,3.74439244 17.2309183,4.76955891 L17.0263714,4.56415819 C18.0473407,5.58938929 18.0385691,7.25693425 17.0220933,8.27341004 L7.5,17.7955037 L4,17.7955037 Z"
            />
            <path
              stroke="currentColor"
              strokeWidth="1.75"
              d="M12,7 L15.1774902,9.99267578"
            />
          </g>
        </svg>
      );
    case "delete":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g fill="currentColor" fillRule="evenodd" transform="translate(4 1)">
            <path d="M9.8457 6.2725C9.6657 6.2695 9.4797 6.3365 9.3437 6.4685 9.2077 6.5995 9.1307 6.7755 9.1257 6.9645L8.8757 15.7075C8.8647 16.1025 9.1697 16.4325 9.5537 16.4425L9.5767 16.4425C9.7527 16.4425 9.9197 16.3765 10.0497 16.2545 10.1897 16.1225 10.2697 15.9435 10.2747 15.7495L10.5247 7.0065C10.5357 6.6135 10.2317 6.2835 9.8457 6.2725M7.0752 6.2715C6.6892 6.2715 6.3752 6.5925 6.3752 6.9855L6.3752 15.7295C6.3752 16.1235 6.6892 16.4435 7.0752 16.4435 7.4612 16.4435 7.7752 16.1235 7.7752 15.7295L7.7752 6.9855C7.7752 6.5925 7.4612 6.2715 7.0752 6.2715" />
            <path d="M11.2881,17.2417 C11.2841,17.3547 11.1821,17.4577 11.0751,17.4577 L3.0751,17.4577 C2.9681,17.4577 2.8671,17.3547 2.8621,17.2427 L2.4171,4.8717 L11.7331,4.8717 L11.2881,17.2417 Z M5.5601,3.1857 L5.6291,2.9357 C5.6611,2.8217 5.8341,2.6857 5.9481,2.6857 L8.2021,2.6857 C8.3161,2.6857 8.4891,2.8217 8.5211,2.9357 L8.5901,3.1857 L5.5601,3.1857 Z M13.3251,3.1857 L10.3061,3.1857 L10.1091,2.4757 C9.8741,1.6347 9.0551,0.9997 8.2021,0.9997 L5.9481,0.9997 C5.0951,0.9997 4.2751,1.6347 4.0411,2.4757 L3.8451,3.1857 L0.8251,3.1857 C0.3701,3.1857 0.0001,3.5637 0.0001,4.0287 C0.0001,4.4727 0.3381,4.8387 0.7661,4.8697 L1.2141,17.3037 C1.2501,18.3177 2.0851,19.1427 3.0751,19.1427 L11.0751,19.1427 C12.0651,19.1427 12.9001,18.3177 12.9361,17.3037 L13.3841,4.8697 C13.8121,4.8387 14.1501,4.4727 14.1501,4.0287 C14.1501,3.5637 13.7801,3.1857 13.3251,3.1857 Z" />
            <path d="M4.8071,6.4683 C4.6711,6.3363 4.4841,6.2583 4.3051,6.2723 C3.9191,6.2833 3.6141,6.6133 3.6251,7.0063 L3.8751,15.7493 C3.8811,15.9443 3.9611,16.1223 4.1001,16.2543 C4.2311,16.3763 4.3981,16.4433 4.5731,16.4433 L4.5961,16.4433 C4.9811,16.4323 5.2861,16.1023 5.2751,15.7073 L5.0251,6.9653 C5.0191,6.7753 4.9421,6.5993 4.8071,6.4683" />
          </g>
        </svg>
      );
    case "cross":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#333"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(10 10)"
          >
            <path d="M12,0 L0,12" />
            <path d="M12,0 L0,12" transform="matrix(-1 0 0 1 12 0)" />
          </g>
        </svg>
      );
    case "cross-20":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 32 32"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#333"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(10 10)"
          >
            <path d="M12,0 L0,12" />
            <path d="M12,0 L0,12" transform="matrix(-1 0 0 1 12 0)" />
          </g>
        </svg>
      );
    case "white-cross-10":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(2 2)"
          >
            <path d="M12,0 L0,12" />
            <path d="M12,0 L0,12" transform="matrix(-1 0 0 1 12 0)" />
          </g>
        </svg>
      );
    case "black-cross-10":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(2 2)"
          >
            <path d="M12,0 L0,12" />
            <path d="M12,0 L0,12" transform="matrix(-1 0 0 1 12 0)" />
          </g>
        </svg>
      );
    case "user":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#333"
            strokeWidth="2"
            transform="translate(.5 1.5)"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0.681818182,12.982906 C0.681818182,12.982906 0.340909091,9.69230769 4.09090909,9.69230769 C7.84090909,9.69230769 7.16761227,9.69230769 10.9133516,9.69230769 C14.6590909,9.69230769 14.3224422,12.982906 14.3224422,12.982906"
            />
            <ellipse cx="7.5" cy="3.829" rx="3.409" ry="3.291" />
          </g>
        </svg>
      );
    case "admin":
      return (
        <svg
          viewBox="0 0 32 32"
          width="32px"
          height="32px"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.9639 22.6354c-.9377.4861-2.0337-.299-1.8546-1.3286l.5321-3.0589-2.254-2.1663c-.75864-.7291-.34001-1.9995.7084-2.1497l3.1149-.4463 1.3931-2.7831c.4689-.93668 1.8235-.93668 2.2924 0l1.3931 2.7831 3.1149.4463c1.0484.1502 1.467 1.4206.7084 2.1497l-2.254 2.1663.5321 3.0589c.1791 1.0296-.9169 1.8147-1.8546 1.3286L15.75 21.1912l-2.7861 1.4442z"
            stroke="currentColor"
            fill="currentColor"
            fillOpacity="0"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "chevron-right-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polyline
            fill="none"
            stroke="#333"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            points="4 2 8 6 4 10"
          />
        </svg>
      );
    case "chevron-left-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polyline
            fill="none"
            stroke="#333"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            points="4 2 8 6 4 10"
            transform="rotate(-180 6 6)"
          />
        </svg>
      );
    case "chevron-up-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polyline
            fill="none"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            points="4 2 8 6 4 10"
            transform="rotate(-90 6 6)"
          />
        </svg>
      );

    case "chevron-down-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polyline
            fill="none"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            points="4 2 8 6 4 10"
            transform="rotate(90 6 6)"
          />
        </svg>
      );

    case "circle-arrow-right-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd" stroke="#333">
            <circle cx="16" cy="16" r="15.25" strokeWidth="1.5" />
            <g
              strokeLinecap="round"
              strokeWidth="2"
              transform="translate(10 11)"
            >
              <path d="M0,5 L10.2857143,5" />
              <polyline strokeLinejoin="round" points="6.667 0 12 5 6.667 10" />
            </g>
          </g>
        </svg>
      );
    case "arrow-right-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#FFF"
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(1.5 2)"
          >
            <path d="M0,4 L7.71428571,4" />
            <polyline strokeLinejoin="round" points="5 0 9 4 5 8" />
          </g>
        </svg>
      );
    case "circle-message-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd">
            <circle
              cx="16"
              cy="16"
              r="15.25"
              stroke="#0abaee"
              strokeWidth="1.5"
            />
            <g transform="translate(8 9)">
              <path
                stroke="#0abaee"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M2.86862915,10.8888889 L5.03431458,12.9944164 L5.6,13.5443884 L6.16568542,12.9944164 L8.33137088,10.8888889 L14.4019643,10.8888889 C15.2856175,10.8888889 16,10.1907717 16,9.33140966 L16,1.55747923 C16,0.703235104 15.2866314,0 14.4052818,0 L1.59471814,0 C0.712464248,0 0,0.698910917 0,1.55747923 L0,9.33140966 C0,10.1866133 0.716381664,10.8888889 1.59916525,10.8888889 L2.86862915,10.8888889 Z"
              />
              <rect
                width="9.6"
                height="2"
                x="3.2"
                y="2.9"
                fill="#0abaee"
                fillRule="nonzero"
                rx=".8"
              />
              <rect
                width="9.6"
                height="2"
                x="3.2"
                y="6"
                fill="#0abaee"
                fillRule="nonzero"
                rx=".8"
              />
            </g>
          </g>
        </svg>
      );

    case "circle-message-plus-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd" stroke="#333">
            <circle cx="16" cy="16" r="15.25" strokeWidth="1.5" />
            <path
              strokeLinejoin="round"
              strokeWidth="2"
              d="M2.86862915,10.8888889 L5.03431458,12.9944164 L5.6,13.5443884 L6.16568542,12.9944164 L8.33137088,10.8888889 L14.4019643,10.8888889 C15.2856175,10.8888889 16,10.1907717 16,9.33140966 L16,1.55747923 C16,0.703235104 15.2866314,0 14.4052818,0 L1.59471814,0 C0.712464248,0 0,0.698910917 0,1.55747923 L0,9.33140966 C0,10.1866133 0.716381664,10.8888889 1.59916525,10.8888889 L2.86862915,10.8888889 Z"
              transform="translate(8 9)"
            />
            <g
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              transform="translate(13 11.5)"
            >
              <path d="M3 .333333333L3 5.66666667M.333333333 3L5.66666667 3" />
            </g>
          </g>
        </svg>
      );
    case "plus-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            transform="translate(1 1)"
          >
            <path d="M7 0L7 14M14 7L0 7" />
          </g>
        </svg>
      );

    case "circle-document-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd" stroke="#333">
            <circle cx="16" cy="16" r="15.25" strokeWidth="1.5" />
            <g
              strokeLinecap="round"
              strokeWidth="2"
              transform="translate(10 8.5)"
            >
              <path
                strokeLinejoin="round"
                d="M0,1.66739305 L0,13.3326069 C0,14.256126 0.768194049,15 1.71640568,15 L10.2835943,15 C11.2267331,15 12,14.2517897 12,13.3312723 L12,4.16666667 L12,3.82119089 L11.7485788,3.57705169 L8.31582214,0.243718358 L8.06483443,0 L7.71010046,0 L1.71121851,0 C0.769895169,0 0,0.7484037 0,1.66739305 Z"
              />
              <polyline points="5 3 5 6 8 6" />
            </g>
          </g>
        </svg>
      );
    case "circle-cloud-download-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd" stroke="#333">
            <circle cx="16" cy="16" r="15.25" strokeWidth="1.5" />
            <g strokeLinecap="round" strokeWidth="2" transform="translate(8 9)">
              <path
                strokeLinejoin="round"
                d="M4.09090909,10.5 L2.90909091,10.5 C1.30244436,10.5 0,9.15685425 0,7.5 C0,5.84314575 1.30244436,4.5 2.90909091,4.5 C3.16974886,4.5 3.42239991,4.53535285 3.66278136,4.6016626 C3.64533168,4.44526952 3.63636364,4.28621479 3.63636364,4.125 C3.63636364,1.84682541 5.42722464,0 7.63636364,0 C9.50351367,0 11.0718659,1.31928368 11.5127017,3.10323488 C11.785667,3.03574406 12.0706039,3 12.3636364,3 C14.3719445,3 16,4.67893219 16,6.75 C16,8.82106778 14.3719445,10.5 12.3636364,10.5 L11.9090909,10.5"
              />
              <path d="M8,7.5 L8,13.5" />
              <polyline
                strokeLinejoin="round"
                points="10.182 12.75 8 15 5.818 12.75"
              />
            </g>
          </g>
        </svg>
      );
    case "white-tick-12":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <polyline
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            points="9.5 0 3.147 6 .5 3.5"
            transform="translate(1 3)"
          />
        </svg>
      );
    case "circle-message-view":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd">
            <circle
              cx="16"
              cy="16"
              r="15.25"
              stroke="#0abaee"
              strokeWidth="1.5"
            />
            <g transform="translate(8 9)">
              <path
                stroke="#0abaee"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M2.86862915,10.8888889 L5.03431458,12.9944164 L5.6,13.5443884 L6.16568542,12.9944164 L8.33137088,10.8888889 L14.4019643,10.8888889 C15.2856175,10.8888889 16,10.1907717 16,9.33140966 L16,1.55747923 C16,0.703235104 15.2866314,0 14.4052818,0 L1.59471814,0 C0.712464248,0 0,0.698910917 0,1.55747923 L0,9.33140966 C0,10.1866133 0.716381664,10.8888889 1.59916525,10.8888889 L2.86862915,10.8888889 Z"
              />
              <rect
                width="9.6"
                height="2"
                x="3.2"
                y="2.9"
                fill="#0abaee"
                fillRule="nonzero"
                rx=".8"
              />
              <rect
                width="9.6"
                height="2"
                x="3.2"
                y="6"
                fill="#0abaee"
                fillRule="nonzero"
                rx=".8"
              />
            </g>
          </g>
        </svg>
      );
    case "circle-bin-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g>
            <circle
              cx="16"
              cy="16"
              r="15.25"
              fill="none"
              stroke="#333"
              strokeWidth="1.5"
            />
            <path
              d="M12.49 8.61l.27-.95a2.1 2.1 0 0 1 2-1.47h2.58a2.1 2.1 0 0 1 1.95 1.47l.27.95h3.62a.71.71 0 1 1 0 1.42H23l-.52 14a1.9 1.9 0 0 1-1.89 1.82h-9.16A1.91 1.91 0 0 1 9.54 24L9 10h-.13a.71.71 0 1 1 0-1.42zm1.48 0H18l-.16-.56a.69.69 0 0 0-.58-.44h-2.55a.69.69 0 0 0-.58.44zM10.45 10L11 23.94a.48.48 0 0 0 .47.45h9.13a.49.49 0 0 0 .47-.45L21.55 10zm5 2.56A.57.57 0 0 1 16 12a.57.57 0 0 1 .57.57v9.66a.57.57 0 0 1-1.14 0v-9.64zm-3.14 0a.57.57 0 0 1 1.14 0l.29 9.67a.57.57 0 0 1-1.14 0zm6.28 0a.57.57 0 0 1 1.14 0l-.29 9.66a.57.57 0 1 1-1.14 0z"
              fill="#333"
            />
          </g>
        </svg>
      );
    case "circle-pen-32":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <g fill="none" fillRule="evenodd" stroke="#333">
            <circle cx="16" cy="16" r="15.25" strokeWidth="1.5" />
            <g strokeWidth="2" transform="translate(9 9)">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0,14.0000003 L0,10.5 L9.52819551,0.971804444 C10.5521834,-0.0521834425 12.2100132,-0.0511109812 13.2309183,0.974055486 L13.0263714,0.768654766 C14.0473407,1.79388587 14.0385691,3.46143083 13.0220933,4.47790662 L3.5,14.0000003 L0,14.0000003 Z"
              />
              <path d="M8.3125,2.1875 L11.8125,5.6875" />
            </g>
          </g>
        </svg>
      );
    case "red-alert-16":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#FF0000"
            transform="translate(1 1)"
          >
            <polygon
              strokeLinejoin="round"
              strokeWidth="1.75"
              points="7.555 1.647 7 .63 6.445 1.647 .718 12.147 .185 13.125 1.273 13.125 12.727 13.125 13.815 13.125 13.282 12.147"
            />
            <path
              fill="#FF0000"
              fillRule="nonzero"
              strokeWidth=".25"
              d="M7,10.9921875 C7.43931739,10.9921875 7.79545455,10.6249211 7.79545455,10.171875 C7.79545455,9.71882894 7.43931739,9.3515625 7,9.3515625 C6.56068261,9.3515625 6.20454545,9.71882894 6.20454545,10.171875 C6.20454545,10.6249211 6.56068261,10.9921875 7,10.9921875 Z"
            />
            <rect
              width="1.273"
              height="3.281"
              x="6.364"
              y="5.25"
              fill="#FF0000"
              fillRule="nonzero"
              strokeWidth=".25"
              rx=".636"
            />
          </g>
        </svg>
      );
    case "green-alert-16":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#35cb93"
            transform="translate(1 1)"
          >
            <polygon
              strokeLinejoin="round"
              strokeWidth="1.75"
              points="7.555 1.647 7 .63 6.445 1.647 .718 12.147 .185 13.125 1.273 13.125 12.727 13.125 13.815 13.125 13.282 12.147"
            />
            <path
              fill="#35cb93"
              fillRule="nonzero"
              strokeWidth=".25"
              d="M7,10.9921875 C7.43931739,10.9921875 7.79545455,10.6249211 7.79545455,10.171875 C7.79545455,9.71882894 7.43931739,9.3515625 7,9.3515625 C6.56068261,9.3515625 6.20454545,9.71882894 6.20454545,10.171875 C6.20454545,10.6249211 6.56068261,10.9921875 7,10.9921875 Z"
            />
            <rect
              width="1.273"
              height="3.281"
              x="6.364"
              y="5.25"
              fill="#35cb93"
              fillRule="nonzero"
              strokeWidth=".25"
              rx=".636"
            />
          </g>
        </svg>
      );
    case "grey-alert-16":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#868e96"
            transform="translate(1 1)"
          >
            <polygon
              strokeLinejoin="round"
              strokeWidth="1.75"
              points="7.555 1.647 7 .63 6.445 1.647 .718 12.147 .185 13.125 1.273 13.125 12.727 13.125 13.815 13.125 13.282 12.147"
            />
            <path
              fill="#868e96"
              fillRule="nonzero"
              strokeWidth=".25"
              d="M7,10.9921875 C7.43931739,10.9921875 7.79545455,10.6249211 7.79545455,10.171875 C7.79545455,9.71882894 7.43931739,9.3515625 7,9.3515625 C6.56068261,9.3515625 6.20454545,9.71882894 6.20454545,10.171875 C6.20454545,10.6249211 6.56068261,10.9921875 7,10.9921875 Z"
            />
            <rect
              width="1.273"
              height="3.281"
              x="6.364"
              y="5.25"
              fill="#868e96"
              fillRule="nonzero"
              strokeWidth=".25"
              rx=".636"
            />
          </g>
        </svg>
      );
    case "orange-alert-16":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#f5a623"
            transform="translate(1 1)"
          >
            <polygon
              strokeLinejoin="round"
              strokeWidth="1.75"
              points="7.555 1.647 7 .63 6.445 1.647 .718 12.147 .185 13.125 1.273 13.125 12.727 13.125 13.815 13.125 13.282 12.147"
            />
            <path
              fill="#f5a623"
              fillRule="nonzero"
              strokeWidth=".25"
              d="M7,10.9921875 C7.43931739,10.9921875 7.79545455,10.6249211 7.79545455,10.171875 C7.79545455,9.71882894 7.43931739,9.3515625 7,9.3515625 C6.56068261,9.3515625 6.20454545,9.71882894 6.20454545,10.171875 C6.20454545,10.6249211 6.56068261,10.9921875 7,10.9921875 Z"
            />
            <rect
              width="1.273"
              height="3.281"
              x="6.364"
              y="5.25"
              fill="#f5a623"
              fillRule="nonzero"
              strokeWidth=".25"
              rx=".636"
            />
          </g>
        </svg>
      );
    case "dashboard":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <path
            fill="#B6B8C7"
            d="M3.74682617,10.7677243 L3.74682617,18.1287609 L7.28051758,18.1287609 L7.28051758,14.990089 C7.28051758,13.4713059 8.51173452,12.240089 10.0305176,12.240089 L12.1171875,12.240089 C13.6359706,12.240089 14.8671875,13.4713059 14.8671875,14.990089 L14.8671875,18.1287609 L18.2468262,18.1287609 L18.2468262,10.7483374 L11.185148,4.80867856 C11.0922895,4.73057426 10.9567544,4.73042506 10.8637243,4.80832472 L3.74682617,10.7677243 Z M1.99682617,10 L9.74021693,3.46659775 C10.4844583,2.84340044 11.5687392,2.84459407 12.3116067,3.46942846 L19.9968262,10 L19.9968262,11.6554943 L19.9968262,18.8787609 C19.9968262,19.4310456 19.5491109,19.8787609 18.9968262,19.8787609 L14.1171875,19.8787609 C13.5649028,19.8787609 13.1171875,19.4310456 13.1171875,18.8787609 L13.1171875,14.990089 C13.1171875,14.4378043 12.6694722,13.990089 12.1171875,13.990089 L10.0305176,13.990089 C9.47823283,13.990089 9.03051758,14.4378043 9.03051758,14.990089 L9.03051758,18.8787609 C9.03051758,19.4310456 8.58280233,19.8787609 8.03051758,19.8787609 L2.99682617,19.8787609 C2.44454142,19.8787609 1.99682617,19.4310456 1.99682617,18.8787609 L1.99682617,11.6226574 L1.99682617,10 Z"
          />
        </svg>
      );
    case "accounts-22":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <path
            fill="#B6B8C7"
            stroke="#B6B8C7"
            d="M18.6,5.84931507 L14.8,5.84931507 L14.8,4.43835616 C14.8,3.6369863 14.18,3 13.4,3 L8.6,3 C7.82,3 7.2,3.6369863 7.2,4.43835616 L7.2,5.84931507 L3.4,5.84931507 C2.62,5.84931507 2,6.48630137 2,7.28767123 L2,17.5616438 C2,18.3630137 2.62,19 3.4,19 L18.6,19 C19.38,19 20,18.3630137 20,17.5616438 L20,7.28767123 C20,6.48630137 19.38,5.84931507 18.6,5.84931507 Z M8,4 L14,4 C14,4 14,4.66666667 14,6 L8,6 L8,4 Z M3.4,6.67123288 L7.6,6.67123288 L14.4,6.67123288 L18.6,6.67123288 C18.94,6.67123288 19.2,6.93835616 19.2,7.28767123 L19.2,10.5136986 C16.48,11.7876712 13.72,12.4246575 11,12.4246575 C8.28,12.4246575 5.52,11.7876712 2.8,10.5136986 L2.8,7.28767123 C2.8,6.93835616 3.06,6.67123288 3.4,6.67123288 Z M11.6,13.2465753 C11.6,13.5958904 11.34,13.8630137 11,13.8630137 C10.66,13.8630137 10.4,13.5958904 10.4,13.2465753 L11.6,13.2465753 Z M18.6,18.1780822 L3.4,18.1780822 C3.06,18.1780822 2.8,17.9109589 2.8,17.5616438 L2.8,11.4178082 C5.06,12.4246575 7.34,13.0205479 9.6,13.1849315 L9.6,13.2465753 C9.6,14.0479452 10.22,14.6849315 11,14.6849315 C11.78,14.6849315 12.4,14.0479452 12.4,13.2465753 L12.4,13.1849315 C14.66,13.0205479 16.94,12.4246575 19.2,11.4178082 L19.2,17.5616438 C19.2,17.9109589 18.94,18.1780822 18.6,18.1780822 Z"
          />
        </svg>
      );
    case "approved-icon":
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 0C4.71036 0 0 4.71036 0 10.5C0 16.2896 4.71036 21 10.5 21C16.2896 21 21 16.2896 21 10.5C21 4.71036 16.2896 0 10.5 0ZM8.58173 15.7692L4.51298 11.2476L5.71392 10.1668L8.54084 13.3077L15.2452 5.3237L16.484 6.36058L8.58173 15.7692Z"
            fill="#35CB94"
          />
        </svg>
      );
    case "explanationIcon":
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 0.984375C5.24467 0.984375 0.984375 5.24467 0.984375 10.5C0.984375 15.7553 5.24467 20.0156 10.5 20.0156C15.7553 20.0156 20.0156 15.7553 20.0156 10.5C20.0156 5.24467 15.7553 0.984375 10.5 0.984375ZM0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5Z"
            fill="#ADB5BD"
          />
          <rect
            x="9.67969"
            y="8.53125"
            width="1.64062"
            height="7.875"
            rx="0.820312"
            fill="#ADB5BD"
          />
          <rect
            x="9.51562"
            y="5.25"
            width="1.96875"
            height="1.96875"
            rx="0.984375"
            fill="#ADB5BD"
          />
        </svg>
      );
    case "pending-approval-icon":
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 0C4.71036 0 0 4.71036 0 10.5C0 16.2896 4.71036 21 10.5 21C16.2896 21 21 16.2896 21 10.5C21 4.71036 16.2896 0 10.5 0Z"
            fill="#F37920"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.42114 10.4819C4.42114 7.13541 7.13602 4.42053 10.4825 4.42053C13.8289 4.42053 16.5438 7.13541 16.5438 10.4819C16.5438 13.8283 13.8289 16.5432 10.4825 16.5432C7.13602 16.5432 4.42114 13.8283 4.42114 10.4819ZM10.4825 5.35304C7.65103 5.35304 5.35365 7.65042 5.35365 10.4819C5.35365 13.3133 7.65103 15.6107 10.4825 15.6107C13.3139 15.6107 15.6113 13.3133 15.6113 10.4819C15.6113 7.65042 13.3139 5.35304 10.4825 5.35304Z"
            fill="#FCFCFC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4116 6.34912C10.6779 6.34912 10.8937 6.55097 10.8937 6.79996V10.4067H13.3045C13.5708 10.4067 13.7867 10.6086 13.7867 10.8575C13.7867 11.1065 13.5708 11.3084 13.3045 11.3084H10.4116C10.1453 11.3084 9.92944 11.1065 9.92944 10.8575V6.79996C9.92944 6.55097 10.1453 6.34912 10.4116 6.34912Z"
            fill="#FCFCFC"
          />
        </svg>
      );
    case "approval-lock-icon":
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 0C4.71036 0 0 4.71036 0 10.5C0 16.2896 4.71036 21 10.5 21C16.2896 21 21 16.2896 21 10.5C21 4.71036 16.2896 0 10.5 0Z"
            fill="#B4B4B4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.71223 4.47647C9.18045 3.98013 9.8155 3.70129 10.4777 3.70129C11.1398 3.70129 11.7749 3.98013 12.2431 4.47647C12.7113 4.97281 12.9744 5.64599 12.9744 6.34791V8.96696C12.9744 9.21058 12.7881 9.40807 12.5583 9.40807C12.3284 9.40807 12.1421 9.21058 12.1421 8.96696V6.34791C12.1421 5.87996 11.9668 5.43118 11.6546 5.10028C11.3425 4.76939 10.9191 4.5835 10.4777 4.5835C10.0362 4.5835 9.61286 4.76939 9.30071 5.10028C8.98856 5.43118 8.81319 5.87996 8.81319 6.34791V8.96696C8.81319 9.21058 8.62689 9.40807 8.39708 9.40807C8.16726 9.40807 7.98096 9.21058 7.98096 8.96696V6.34791C7.98096 5.64599 8.244 4.97281 8.71223 4.47647Z"
            fill="#FCFCFC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.07293 9.44559C6.5357 9.44559 6.10019 9.78178 6.10019 10.1965V14.3264C6.10019 14.7411 6.5357 15.0773 7.07293 15.0773H13.8821C14.4194 15.0773 14.8549 14.7411 14.8549 14.3264V10.1965C14.8549 9.78178 14.4194 9.44559 13.8821 9.44559H7.07293ZM5.12744 10.1965C5.12744 9.36707 5.99847 8.6947 7.07293 8.6947H13.8821C14.9566 8.6947 15.8276 9.36707 15.8276 10.1965V14.3264C15.8276 15.1558 14.9566 15.8282 13.8821 15.8282H7.07293C5.99847 15.8282 5.12744 15.1558 5.12744 14.3264V10.1965Z"
            fill="#FCFCFC"
          />
        </svg>
      );
    case "right-tick":
      return (
        <svg
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 4.34031L3.42444 8L10 0.993035L9.05597 0L3.42444 5.99996L0.930956 3.34028L0 4.34031Z"
            fill="#F3F3F3"
          />
        </svg>
      );
    case "small-right-tick-circle":
      return (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 0C3.36454 0 0 3.36454 0 7.5C0 11.6355 3.36454 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.36454 11.6355 0 7.5 0ZM6.12981 11.2637L3.22356 8.03401L4.08137 7.26202L6.1006 9.50553L10.8894 3.80264L11.7743 4.54327L6.12981 11.2637Z"
            fill="#35CB94"
          />
        </svg>
      );
    case "confirm-approval-icon":
      return (
        <svg
          width="59"
          height="59"
          viewBox="0 0 59 59"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.53 0C45.7796 0 59 13.2204 59 29.47C59 45.7196 45.7796 58.94 29.53 58.94C13.2804 58.94 0.0600052 45.7196 0.0600052 29.47C0.0600052 13.2204 13.2804 0 29.53 0ZM26.6963 45.3257H32.3637V39.6584H26.6963V45.3257ZM27.2631 36.2708H31.7969L32.647 13.6015H26.413L27.2631 36.2708Z"
            fill="#E27511"
          />
        </svg>
      );
    case "approved-note-icon":
      return (
        <svg
          width="59"
          height="60"
          viewBox="0 0 59 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.4696 0.219482C13.2202 0.219482 0 13.4397 0 29.6891C0 45.9385 13.2202 59.1588 29.4696 59.1588C45.719 59.1588 58.9393 45.9385 58.9393 29.6891C58.9393 13.4397 45.719 0.219482 29.4696 0.219482ZM24.0858 44.4778L12.6663 31.7874L16.0369 28.754L23.971 37.5694L42.7876 15.1612L46.2645 18.0713L24.0858 44.4778Z"
            fill="#35CB94"
          />
        </svg>
      );
    default:
      return null;
  }
};

export default SVGIcon;
